import React from "react";

const FAQ = () => {
  return (
    <div class="max-w-3xl mx-auto mt-16 pt-16">
      <article>
        <header>
          <h1 class="h1 text-3xl">Foire Aux Questions</h1>{" "}
        </header>

        <div class="page-content">
          <div class="mt-12 md:mt-20">
            <h3 class="h3 mb-8">Purchased templates &amp; Unlimited Access</h3>
            <ul class="accordion mt-8">
              <li class="border-t border-gray-200">
                <button
                  class="text-left text-gray-900 text-lg font-medium accordion-header w-full flex justify-between items-center m-0 py-5 px-4"
                  style={{ outline: "none" }}
                >
                  <div class="flex-grow">
                    Can I use the templates for commercial and client projects?
                  </div>
                  <div class="accordion-icon ml-2"></div>
                </button>
                <div class="accordion-body px-4">
                  <div class="mb-5">
                    Yes! You can use the templates in both commercial and client
                    projects.
                  </div>
                </div>
              </li>
              <li class="border-t border-gray-200">
                <button
                  class="text-left text-gray-900 text-lg font-medium accordion-header w-full flex justify-between items-center m-0 py-5 px-4"
                  style={{ outline: "none" }}
                >
                  <div class="flex-grow">
                    What does "use in unlimited projects" mean?
                  </div>
                  <div class="accordion-icon ml-2"></div>
                </button>
                <div class="accordion-body px-4">
                  <div class="mb-5">
                    ​​You can use the templates to create as many projects as
                    you want without having to worry about limits or
                    restrictions. In other words, you can create an unlimited
                    number of projects using the same template/license.
                  </div>
                </div>
              </li>
              <li class="border-t border-gray-200">
                <button
                  class="text-left text-gray-900 text-lg font-medium accordion-header w-full flex justify-between items-center m-0 py-5 px-4"
                  style={{ outline: "none" }}
                >
                  <div class="flex-grow">
                    How many new templates are you planning to release?
                  </div>
                  <div class="accordion-icon ml-2"></div>
                </button>
                <div class="accordion-body px-4">
                  <div class="mb-5">
                    We plan to release a new template every 2/3 months!
                  </div>
                </div>
              </li>
              <li class="border-t border-gray-200">
                <button
                  class="text-left text-gray-900 text-lg font-medium accordion-header w-full flex justify-between items-center m-0 py-5 px-4"
                  style={{ outline: "none" }}
                >
                  <div class="flex-grow">
                    What kind of new templates will you release?
                  </div>
                  <div class="accordion-icon ml-2"></div>
                </button>
                <div class="accordion-body px-4">
                  <div class="mb-5">
                    Landing pages, websites, and dashboards built on top of
                    Tailwind CSS.
                  </div>
                </div>
              </li>
              <li class="border-t border-gray-200">
                <button
                  class="text-left text-gray-900 text-lg font-medium accordion-header w-full flex justify-between items-center m-0 py-5 px-4"
                  style={{ outline: "none" }}
                >
                  <div class="flex-grow">How does the support work?</div>
                  <div class="accordion-icon ml-2"></div>
                </button>
                <div class="accordion-body px-4">
                  <div class="mb-5">
                    The support gives you directions/suggestions on how to use
                    the product as advertised. Please note that the support
                    doesn't cover complex customisation requests or step-by-step
                    directions for non-technical people.
                  </div>
                </div>
              </li>
              <li class="border-t border-b border-gray-200">
                <button
                  class="text-left text-gray-900 text-lg font-medium accordion-header w-full flex justify-between items-center m-0 py-5 px-4"
                  style={{ outline: "none" }}
                >
                  <div class="flex-grow">
                    If I'm not happy with my purchase, can I get a refund?
                  </div>
                  <div class="accordion-icon ml-2"></div>
                </button>
                <div class="accordion-body px-4">
                  <div class="mb-5">
                    ​​Due to the nature of our digital goods, refunds are issued
                    on a very discretionary basis! If you would like to learn
                    more about our refund policy please have a look at our list
                    of{" "}
                    <a
                      href="https://cruip.com/privacy-policy/"
                      style={{ outline: "none" }}
                    >
                      Acceptable Reasons For Refund
                    </a>
                    , or contact us directly if you’ve any questions.
                  </div>
                </div>
              </li>
            </ul>{" "}
          </div>
          <div class="mt-12">
            <h3 class="h3 mb-8">General &amp; License</h3>
            <ul class="accordion mt-8">
              <li class="border-t border-gray-200">
                <button
                  class="text-left text-gray-900 text-lg font-medium accordion-header w-full flex justify-between items-center m-0 py-5 px-4"
                  style={{ outline: "none" }}
                >
                  <div class="flex-grow">
                    Can I host, redistribute or resell a template?
                  </div>
                  <div class="accordion-icon ml-2"></div>
                </button>
                <div class="accordion-body px-4">
                  <div class="mb-5">
                    No, you cannot host, redistribute, or resell any template
                    from Cruip.com. For more information about our license,
                    please have a look at our list of Rights and Prohibitions,
                    or contact us directly if you've questions.
                  </div>
                </div>
              </li>
              <li class="border-t border-gray-200">
                <button
                  class="text-left text-gray-900 text-lg font-medium accordion-header w-full flex justify-between items-center m-0 py-5 px-4"
                  style={{ outline: "none" }}
                >
                  <div class="flex-grow">
                    Can I use Cruip if I'm not a developer?
                  </div>
                  <div class="accordion-icon ml-2"></div>
                </button>
                <div class="accordion-body px-4">
                  <div class="mb-5">
                    ​​You should have a basic knowledge of HTML and CSS to
                    install and customise a template.
                  </div>
                </div>
              </li>
              <li class="border-t border-gray-200">
                <button
                  class="text-left text-gray-900 text-lg font-medium accordion-header w-full flex justify-between items-center m-0 py-5 px-4"
                  style={{ outline: "none" }}
                >
                  <div class="flex-grow">
                    Can I use the free templates for my personal and commercial
                    projects?
                  </div>
                  <div class="accordion-icon ml-2"></div>
                </button>
                <div class="accordion-body px-4">
                  <div class="mb-5">
                    Yes! You can use the free templates in both commercial and
                    client projects.
                  </div>
                </div>
              </li>
              <li class="border-t border-gray-200">
                <button
                  class="text-left text-gray-900 text-lg font-medium accordion-header w-full flex justify-between items-center m-0 py-5 px-4"
                  style={{ outline: "none" }}
                >
                  <div class="flex-grow">
                    What are the attribution requirements when I use a Cruip
                    template?
                  </div>
                  <div class="accordion-icon ml-2"></div>
                </button>
                <div class="accordion-body px-4">
                  <div class="mb-5">
                    We don't require any attributions. Precisely, you don't need
                    to credit Cruip or linking back to us if you use any
                    template for your commercial or client projects.
                  </div>
                </div>
              </li>
              <li class="border-t border-b border-gray-200">
                <button
                  class="text-left text-gray-900 text-lg font-medium accordion-header w-full flex justify-between items-center m-0 py-5 px-4"
                  style={{ outline: "none" }}
                >
                  <div class="flex-grow">
                    Can I use a Cruip template in WordPress or Shopify?
                  </div>
                  <div class="accordion-icon ml-2"></div>
                </button>
                <div class="accordion-body px-4">
                  <div class="mb-5">
                    ​​There is no version of our templates available for
                    WordPress or Shopify at the moment. If you want to use one
                    of our products in WordPress/Shopify you might need to slice
                    the HTML template and build a WordPress/Shopify theme.
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </article>
    </div>
  );
};

export default FAQ;
